import {
  Box,
  Container,
  Text,
  Button,
  Image,
  useInterval,
  Flex,
  SimpleGrid,
  Center,
  Heading,
} from '@chakra-ui/react'
import { MainLayout } from '../../layouts/MainLayout'
import { useCallback, useEffect, useState, useRef } from 'react'
import toast from 'react-hot-toast'
import { clusterApiUrl, Connection, Keypair, PublicKey } from '@solana/web3.js'
import { getPuffPrice, getSolPrice } from '../../utils/sacUtils'
import { findReference } from '@solana/pay'
import { CalcBackIcon } from '../../components/Icons'
import { QRPayScan } from '../../modules/puffPay/QRPayScan'
import { PaySuccess } from '../../modules/puffPay/PaySuccess'
import { PayFailed } from '../../modules/puffPay/PayFailed'
import { SlideButton } from '../../components/SlideButton'
import { PayProcessing } from '../../modules/puffPay/PayProcessing'
import { trpc } from '../../utils/trpc'
import { useRouter } from 'next/router'
import Link from 'next/link'
import { RiInformationLine } from 'react-icons/ri'

export const enum CURRENCY {
  puff = 'PUFF',
  sol = 'SOL',
  usdc = 'USDC',
}

export default function Demo() {
  const router = useRouter()

  return (
    <MainLayout
      navbar={{
        colorTheme: 'white',
        bgTransparent: true,
      }}
    >
      <Box>
        <Container
          maxW='100vw'
          minHeight='100vh'
          pr='0'
          pl='0'
          pb='2rem'
          paddingInlineStart={0}
          paddingInlineEnd={0}
          bg=''
          pos='relative'
          _before={{
            content: '""',
            position: 'absolute',
            width: '100%',
            height: '100%',
            opacity: '0.95',
            zIndex: -1,
          }}
        >
          <Flex
            pt='.4rem'
            flexDirection='column'
            width={'fit-content'}
            maxW={['96%', '80%', '54%']}
            marginX='auto'
            px='1.5rem'
          >
            <Flex mb={['.8rem', '1.6rem']} justifyContent={'center'} alignItems={'center'} paddingY='.4rem'>
              <Image maxHeight='30px' color='#28374B' src='/icons/SAC_PayLeaf_Logo_black-01.svg'></Image>
            </Flex>
            <Heading fontFamily='Qualy' fontSize='2rem' color='#676767'>
              <Heading as="span" color='#28374B'>PayLeaf</Heading> aims to provide stores with a <Heading as="span" color='#28374B'>simple solution</Heading> to <Heading as="span" color='#28374B'>accept mobile payments.</Heading>
            </Heading>
            <Text mt={['1rem', '2rem']} fontSize='1.2rem' fontWeight={600} color='#676767'>
              Here you can try out the payment process consisting of <br/>
              1. A merchant entering the USD amount and selecting the payment currency<br/>
              2. Customer scanning the QR code in Phantom mobile and approving the transaction
            </Text>
            
            <Link href='https://www.payleaf.io/pay/cl7t9emht02131ulplm8tqb8q'>
              <Button
                mt={['1.4rem', '3rem']}
                bg='greenPay'
                _hover={{ opacity: 0.9 }}
                color='white'
                border='none'
                paddingX='1.8rem'
                width='180px'
              >
                Try it out now
              </Button>
            </Link>
            <Box mt={['1rem', '2rem']}>
          <Flex
            style={{
              background: '#FAFAFB',
              borderRadius: '14px',
            }}
            padding={['1rem', '1rem 2rem']}
            alignItems='center'
            gap='.5rem'
            color='#949BA5'
          >
            <RiInformationLine />
            <Text fontSize={'1rem'} fontWeight={300}>
              Make sure to use the latest version of Phantom.
            </Text>
          </Flex>
        </Box>
          </Flex>
        </Container>
      </Box>
    </MainLayout>
  )
}